import React, {useEffect, useMemo, useState} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import ProPaymentTable from '../../features/page/user/ProPaymentTable'
import useQueryProHistory from '../../hooks/api/user/useQueryProHistory'
import {IPro} from '../../apis/user/getProHistoryList'
import WizSelectButton from '../../components/button/WizSelectButton'
import Text from '../../components/text/Text'
import Span from '../../components/text/Span'

interface IProps {
    className?: string
}

const ProPaymentPage: React.FC<IProps> = ({className}) => {
    const [sortBy, setSortBy] = useState('active')
    const [currentPage, setCurrentPage] = useState(1)

    const {data: proData, refetch} = useQueryProHistory(currentPage)

    const userList = useMemo(() => {
        let list: IPro[] = []
        proData?.data?.map(item => list.push(item))
        return list
    }, [proData])

    useEffect(() => {
        refetch()
    }, [currentPage])

    const sortList = useMemo(
        () => [
            {id: 'active', value: 'Active'},
            {id: 'deActive', value: 'DeActive'},
        ],
        [],
    )

    const activeProUserList = useMemo(() => {
        return userList
            ?.filter(item => new Date(item?.end_at).getTime() > new Date().getTime())
            .sort((a, b) => new Date(a.end_at).getTime() - new Date(b.end_at).getTime())
    }, [userList])

    const deActiveProUserList = useMemo(() => {
        return userList
            ?.filter(item => new Date(item?.end_at).getTime() < new Date().getTime())
            .sort((a, b) => new Date(b.end_at).getTime() - new Date(a.end_at).getTime())
    }, [userList])

    return (
        <PageLayout title={'Pro Payment'} className={className}>
            <WizSelectButton
                onChange={e => {
                    setSortBy(e.id)
                }}
                data={sortList}
                activeValue={sortList?.find(item => item.id === sortBy)}
            />

            <Text className={'mt-[20px] text-[16px]'}>
                Active Payment :{' '}
                <Span className={'text-h3 text-alt_blue'}>{` ${activeProUserList?.length || '-'}`}</Span>
            </Text>

            <ProPaymentTable
                data={sortBy === 'active' ? activeProUserList : deActiveProUserList}
                className={'mt-[30px]'}
            />
            {/*<WizPagination*/}
            {/*    totalPage={proData?.pageInfo?.total_count}*/}
            {/*    currentPage={currentPage}*/}
            {/*    onPageChange={item => setCurrentPage(item)}*/}
            {/*/>*/}
        </PageLayout>
    )
}

export default ProPaymentPage
